// extracted by mini-css-extract-plugin
module.exports = {"label":"workingDay_label__1FjWX","fromTo":"workingDay_fromTo__2Hday"};